<div class="wrapper">
  <div class="doc-dialog-header ">
    <p> Upload file</p>
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <p *ngIf="getFilesArray().length<1">No File Chose </p>
    <mat-list>
      <mat-list-item *ngFor="let file of getFilesArray(); index as i">
        <mat-icon matListIcon>
          <i class="fi-rr-form"></i>
        </mat-icon>
        <!-- ! removed filesize pipe from the below h3 tags -->
        <h3 matLine> {{file.name}}, <span> {{file.size}}</span> </h3>
        <p matLine>
          <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
        </p>
        <p matLine *ngIf="file.uploaded">Uppload</p>
        <button mat-icon-button (click)="removeFile(file.name)" *ngIf="!file.uploaded">
          <mat-icon> close </mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>


  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()">
      Close
    </button>

    <button mat-button class="doc-btn-success" (click)="fileUpload.click()">
      Close
      <mat-icon class="attachmentIcon">
        <i class="fi-rr-clip"></i>
      </mat-icon>
    </button>
  </mat-dialog-actions>

</div>

<input type="file"  [multiple]="multi" class="d-none" (change)="onFileSelected($event)" #fileUpload>
<!-- accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" -->
